export enum UpcAndQrBarcodeSubType {
  UprLeft = 1,
  UprRight = 2,
}
